import { IRootState } from "../../../redux/rootReducer";

export const authMapState = (state: IRootState) => ({
    auth: state.auth
})